
const AboutHero = ({ data }) => (
  <section className="relative bg-gradient-to-br from-[#0a363c] via-[#17484e] to-[#0a363c]/90 text-white py-24 overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <svg width="100%" height="100%" viewBox="0 0 1440 320" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute bottom-0 left-0 w-full h-40 opacity-30">
        <path fill="#e2bf9c" fillOpacity="0.15" d="M0,160L60,170.7C120,181,240,203,360,197.3C480,192,600,160,720,133.3C840,107,960,85,1080,101.3C1200,117,1320,171,1380,197.3L1440,224L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
      </svg>
    </div>
    <div className="relative z-10 max-w-7xl mx-auto px-6 flex flex-col-reverse md:flex-row items-center gap-16">
      {/* Left Content */}
      <div className="md:w-1/2 text-center md:text-left animate-fadein">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-6 tracking-tight leading-tight drop-shadow-lg">
          {data.title}
        </h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-[#e2bf9c] mb-6 drop-shadow">
          {data.subtitle}
        </h2>
        <p className="text-lg md:text-xl leading-relaxed text-white/90 mb-6 max-w-lg mx-auto md:mx-0">
          {data.description}
        </p>
      </div>

      {/* Right Image */}
      <div className="md:w-1/2 flex justify-center animate-fadein-slow">
        <div className="relative w-full max-w-lg aspect-square">
          <img
            src={data.image}
            alt="About Hero"
            className="rounded-3xl shadow-2xl w-full h-full object-cover border-4 border-[#e2bf9c]/30"
          />
          <div className="absolute -inset-4 rounded-3xl border-2 border-[#e2bf9c]/40 animate-pulse-slow"></div>
        </div>
      </div>
    </div>
    <style jsx>{`
      @keyframes fadein {
        from { opacity: 0; transform: translateY(30px); }
        to { opacity: 1; transform: none; }
      }
      .animate-fadein { animation: fadein 1s cubic-bezier(.4,0,.2,1) both; }
      .animate-fadein-slow { animation: fadein 1.5s cubic-bezier(.4,0,.2,1) both; }
      @keyframes pulse-slow {
        0%, 100% { opacity: 0.5; }
        50% { opacity: 1; }
      }
      .animate-pulse-slow { animation: pulse-slow 2.5s infinite; }
    `}</style>
  </section>
);

export default AboutHero;
